import { useState, useEffect } from "react";
import "./WazKBToolbar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { KB_MENUS, selectUIStates, setUIStates } from "../../../redux/features/appData";

type WazKBToolbarProps = {

}

export const WazKBToolbar = ({} : WazKBToolbarProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const uiStates = useSelector(selectUIStates)

    return (
        <div className="waz-kb-toolbar">
            <div className="waz-kb-toolbar-section">
                Knowledge Base
            </div>

            <div 
                className="waz-kb-toolbar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.ADD}));
                    navigate("/kb/add")
                }}
            >
                Add
            </div>

            <div 
                className="waz-kb-toolbar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.MANAGE}));
                    navigate("/kb/manage")
                }}
            >
                Manage
            </div>

            <div 
                className="waz-kb-toolbar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.PERSONAS}));
                    navigate("/kb/personas")
                }}
            >
                Personas
            </div>

            <div 
                className="waz-kb-toolbar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.DASHBOARD}));
                    navigate("/kb/dashboard")
                }}
            >
                Dashboard
            </div>
           
        </div>
    )
}